module.exports = __webpack_public_path__ + "img/logo.40d73ed3.png";